export function topologicalSort(array, getName, getDependencies) {
  const nameToIndex = new Map();
  for (let i = 0; i < array.length; i++) {
    nameToIndex.set(getName(array[i]), i);
  }

  const dependants = new Array(array.length);
  for (let i = 0; i < array.length; i++) {
    dependants[i] = [];
  }

  const incoming = new Int32Array(array.length);
  for (let i = 0; i < array.length; i++) {
    for (const dep of getDependencies(array[i])) {
      const index = nameToIndex.get(dep);
      if (index === undefined) {
        continue;
      }
      incoming[i]++;
      dependants[index].push(i);
    }
  }

  const queue = [];
  for (const item of array) {
    const index = nameToIndex.get(getName(item));
    if (incoming[index] === 0) {
      queue.push(index);
    }
  }

  const result = [];
  while (queue.length > 0) {
    const index = queue.shift();
    result.push(array[index]);
    for (const depIndex of dependants[index]) {
      if (--incoming[depIndex] === 0) {
        queue.push(depIndex);
      }
    }
  }

  return result;
}
